export { default } from './DeleteSuccess';
